"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$Crawler = exports.GoogleCrawlerSubType = exports.CrawlerType = void 0;
const jotai_1 = require("jotai");
var CrawlerType;
(function (CrawlerType) {
    CrawlerType["Google"] = "google";
})(CrawlerType = exports.CrawlerType || (exports.CrawlerType = {}));
var GoogleCrawlerSubType;
(function (GoogleCrawlerSubType) {
    GoogleCrawlerSubType["GoogleAPIs"] = "google_apis";
    GoogleCrawlerSubType["AdsBot"] = "ads_bot";
    GoogleCrawlerSubType["AdSense"] = "mediapartners";
    GoogleCrawlerSubType["Image"] = "image";
    GoogleCrawlerSubType["News"] = "news";
    GoogleCrawlerSubType["Video"] = "video";
    GoogleCrawlerSubType["GoogleBot"] = "googlebot";
    GoogleCrawlerSubType["GoogleBot$Mobile"] = "googlebot(mobile)";
    GoogleCrawlerSubType["FeedFetcher"] = "feed_fetcher";
    GoogleCrawlerSubType["ReadAloud"] = "read_aloud";
    GoogleCrawlerSubType["Favicon"] = "favicon";
    GoogleCrawlerSubType["Storebot"] = "store_bot";
    GoogleCrawlerSubType["SiteVerification"] = "site_verification";
})(GoogleCrawlerSubType = exports.GoogleCrawlerSubType || (exports.GoogleCrawlerSubType = {}));
exports.$Crawler = (0, jotai_1.atom)({});
exports.$Crawler.debugLabel = '$Crawler';
